import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import LayoutDesktop from 'layouts/layout/layout.desktop';
import Breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import CompanyViewHeaderDesktop from 'components/company-view/company-view-header/company-view-header.desktop';
import CompanyViewCardDesktop from 'components/company-view/company-view-card/company-view-card.desktop';
import CompanyViewTabsDesktop from 'components/company-view/company-view-tabs/company-view-tabs.desktop';
import CompanyViewPresellDesktop from 'components/company-view/presell/company-view-presell.desktop';
import CompanyViewOpiconnect from 'components/company-view/company-view-opiconnect/company-view-opiconnect';
import PartnersGrid from 'components/partners/partners-grid';
import AdSlot from 'components/ads/ad-slot';
import { SLOT_BILLBOARD } from 'components/ads/ad-slot/ad-defs';
import { location } from '../../../reducers/location.reducer';
import { productReviews } from '../../../reducers/product-reviews.reducer';
import CompanyViewBeCarefulDesktop from 'components/company-view/be-careful/company-view-be-careful.desktop';
import CompanyViewAnnouncementDesktop from 'components/company-view/announcement/company-view-announcement.desktop';
import CompanyViewRestricted from 'components/company-view/restricted/company-view-restricted';
import CompanyViewBestOffersDesktop from 'components/company-view/best-offers/company-view-best-offers.desktop';
import { useCompany } from 'hooks/use-selector';

const CompanyViewDesktop: React.FC = () => {
    const company = useCompany();

    if (!company) {
        return null;
    }

    return (
        <LayoutDesktop>
            <Breadcrumbs />
            <AdSlot name={SLOT_BILLBOARD} className="onet-ad__billboard" injectAdsenseOnEmpty={true} />
            <div className="company-view">
                <CompanyViewHeaderDesktop />
                <CompanyViewAnnouncementDesktop />
                <CompanyViewBeCarefulDesktop />
                <CompanyViewCardDesktop />
                <CompanyViewPresellDesktop />
                <CompanyViewBestOffersDesktop />
                <CompanyViewOpiconnect />
                <CompanyViewTabsDesktop />
                <CompanyViewRestricted />
            </div>
            <PartnersGrid />
        </LayoutDesktop>
    );
};

export default withHydrate(CompanyViewDesktop, { root: '#root', reducers: { location, productReviews } }, 'views/pages/company/company-view.desktop');
